<ng-container *ngIf="!isDeliveryConfirmation">
  <div *ngIf="deliveryCurrent" class="basket-confirm">

    <app-delivery-list
      [deliveryCurrent]="deliveryCurrent"
      [deliveryList]="deliveryList"
      [wars]="wars"
      (deliveryChange)="switchesDeliveryType($event)"
    />

    <div *ngIf="!dozakazDate && summaUah < user.del_summa1" class="del-type-error">
      <p>
        Для зміни умов доставки зверніться до адміністратора.<br>
        Меню - наші контакти.
      </p>
      <div class="del-type-error-body">
        <b>
          До {{ user.del_summa1 }} грн. можливі замовлення самовивозом, відправка перевізником.<br><br>
          Замовлення від {{ user.del_summa1 }} грн. - вартість доставки {{ user.del_cost }} грн;<br><br>
          Замовлення від {{ user.del_summa2 }} грн. - доставка за наш рахунок!<br><br>
          Важливо! Приймаємо дозаказ до 10-00 дня поставки.
          Якщо до дня поставки наберете суму поставки {{ user.del_summa2 }} грн і вище,
          система автоматично відніме {{ user.del_cost }} грн з доставки.
        </b>
        <br>
        <a class="button" routerLink="/account">Ознайомлений</a>
      </div>
    </div>

    <div *ngIf="!(!dozakazDate && summaUah < user.del_summa1)" class="del-type">
      <div class="del-type-comment"
           [innerHTML]="deliveryCurrent.comment"
      ></div>

      <div class="del-type-address">
        <label>Адреса доставки</label>
        <div>
          <ng-container *ngIf="delivery === 1; else addressInput">
          <textarea
            #scrollInputRef
            type="text"
            placeholder="Введіть адресу доставки"
            [class.border-wrong]="wrongDeliveryTargetAddress"
            [(ngModel)]="lastAddress.city"
            (input)="searchAddressInput(lastAddress.city)"
            rows="2"
          ></textarea>
            <div class="address-suggest" *ngIf="isAddressSuggestionsOpen">
              <button type="button" class="suggest-close" (click)="closeSuggestions()"></button>
              <div
                class="item"
                *ngFor="let s of addressSuggestions"
                (click)="selectAddressSuggestion(s)"
              >
                {{ s.text }}
                <div class="address-hint">Без номера будинку — допишіть вручну</div>
              </div>
            </div>
          </ng-container>
          <ng-template #addressInput>
            <input
              #scrollInputRef
              type="text"
              placeholder="Введіть адресу доставки"
              [class.border-wrong]="wrongDeliveryTargetAddress"
              [(ngModel)]="lastAddress.city"
              (input)="searchAddressInput(lastAddress.city)"
            >
          </ng-template>
          <button
            type="button"
            *ngIf="delivery !== 1 && lastAddress.city !== ''"
            class="cross-clears"
            (click)="crossClearAddress()">
          </button>

          <span *ngIf="wrongDeliveryTargetAddress && delivery === 1" class="status-error">
            Введіть адресу доставки мінімум 4 символи
          </span>
          <span *ngIf="wrongDeliveryTargetAddress && delivery !== 1" class="status-error">
            Введіть адресу доставки мінімум 10 символи
          </span>
        </div>
      </div>

      <div class="del-type-phone">
        <label>Телефон</label>
        <div>
          <input
            type="text"
            #phoneRef
            appPhoneMask
            [class.border-wrong]="wrongLastAddressPhone"
            [(ngModel)]="lastAddress.phone"
            (input)="inputLastAddressPhone()"
          >
          <button type="button" *ngIf="lastAddress.phone !== '' && !wrongLastAddressPhone" class="cross-clears"
                  (click)="crossClearPhone()"></button>
          <span *ngIf="wrongLastAddressPhone" class="status-error">
            Введіть номер телефону
          </span>
        </div>
      </div>

      <div *ngIf="deliveryCurrent.working_details.will_be_transfer" class="del-type-date-limited">
        <div>
          Дати доставки обмежені в зв'язку з переміщенням з іншого складу
        </div>
      </div>

      <div *ngIf="deliveryCurrent.allow_delivery_dates" class="del-type-date">
        <label>
          Дата доставки
        </label>
        <div *ngIf="dozakazDate" class="del-type-date-container">
          <small>Дозамовлення на дату: {{ dozakazDate }}</small>
          <ng-container *ngIf="dozakazDate === ''">
            <label *ngIf="!deliveryCurrent.allow_delivery_dates">
              По прибуттю товару
            </label>
          </ng-container>
        </div>
        <div *ngIf="!dozakazDate">
          <select
            [class.border-wrong]="wrongDeliveryDates"
            [(ngModel)]="deliveryDate"
            (change)="onUserChangeDeliveryDate()"
          >
            <option value="-1">
              Виберіть дату доставки
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates" [value]="date">
              {{ date }}
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryDates">Виберіть дату доставки</span>
        </div>
      </div>

      <div *ngIf="separateOrders && deliveryCurrent?.delivery_dates_zak?.length" class="del-type-date">
        <label>
          Дата відправки переміщення з іншого складу
        </label>
        <div>
          <select
            [class.border-wrong]="wrongDeliverySeparate"
            [(ngModel)]="deliverySeparate"
            (change)="changingValueDeliverySeparate()"
          >
            <option value="-1">
              Вкажіть дату відправлення
            </option>
            <option *ngFor="let date of deliveryCurrent.delivery_dates_zak" [value]="date">
              {{ date }}
            </option>
          </select>
          <span *ngIf="wrongDeliverySeparate" class="status-error">
            Вкажіть дату відправлення
          </span>
        </div>
      </div>

      <div *ngIf="deliveryHoursList.length" class="del-type-date">
        <label>
          Час відправки
        </label>
        <div>
          <select [class.border-wrong]="wrongDeliveryHours"
                  [(ngModel)]="deliveryHours"
                  (change)="changingValueDeliveryHours()">
            <option value="-1">
              Виберіть час відправки
            </option>
            <option *ngFor="let hour of deliveryHoursList" [value]="hour">
              {{ hour }}:00
            </option>
          </select>
          <span class="status" [class.status-error]="wrongDeliveryHours">Виберіть час відправки</span>
        </div>
      </div>

      <span *ngIf="showMessageOtgrujaem" class="message-otgrujaem">
        Включено відвантаження без оплати
      </span>

      <div class="del-type-user-comment">
        <label>Коментар до замовлення</label>
        <div>
          <textarea [(ngModel)]="deliveryComment"></textarea>
        </div>
      </div>

      <div class="del-type-send">
        <a routerLink="/basket">Редагувати замовлення</a>
        <small *ngIf="deliveryCurrent.working_details.will_be_transfer">
          Відвантаження доступно після надходження товарів з іншого складу
        </small>
        <div class="del-type-send-button">
          <app-order-in-progress-message [show]="showOrderInProgressMessage"/>
          <button class="button" [disabled]="isSendingPayment" (click)="sendPayment()">Відправити</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-message-delivery-confirm/>


